import NoDocumentFoundPage from "../../../components/templates/noDocumentsFoundPage";
export var VehicleModule = function () {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NoDocumentFoundPage, {
        title: "No Vehicle Found",
        paragraph: "Coming Soon ..."
    }));
};
